import React, { useState, useEffect, useRef,forwardRef, useImperativeHandle, useMemo } from 'react';
import { Button, Modal, Space, message, Layout, Card, Spin, Select, List, Checkbox, Tabs, Input, Upload } from 'antd';
import { ReloadOutlined, FolderOpenOutlined, PlusOutlined, DeleteOutlined, UploadOutlined, ReadOutlined } from '@ant-design/icons';
import { handleException,downloadFile, useHeighter,OpenDialog,deleteRecord,waitRef,delay } from './Utils';
import { hasRight,getUser,isAdmin} from './Login';
import axiosInstance from './axiosInstance';
import TableLoan from './TableLoan';
import FormLoan from './FormLoan';
import FormNote from './FormNote';

import moment from 'moment';
const { Header, Content, Footer } = Layout;

function ModuleLoan({visible=true, type=0, assigned}) {
	const [tableHeight] = useHeighter(300);	
	const dlgRef = useRef(null);
	const tableRef = useRef(null);
	const formRef = useRef(null);
	const noteDlgRef = useRef(null);
	const noteFormRef = useRef(null);
	const writeRight = hasRight('loans','W');
	const assignLoanRight = hasRight('assign_loan');
	const [autorefresh, setAutorefresh] = useState(false);		
	const [timerId, setTimerId] = useState(null);
	const params = useMemo(() => ({
		title:['Nepřidělené půjčky','Přidělené půjčky','Vše','Koš'][type],
		searchData:[
			[{field:'lenderId', operator:'is null'},{field:'removed', operator:'is', value:0}],
			[{field:'lenderId', operator: writeRight?'is not null':'is', value:getUser().userId},{field:'removed', operator:'is', value:0}],
			[{field:'removed', operator:'is', value:0}],
			[{field:'removed', operator:'is', value:1}]
		][type].filter(e => e.field != 'removed'),
		lender:[false,true,true,true][type],
	}),[type,writeRight]);

	useEffect(() => {
		//if (visible) tableRef.current.refresh()
	}, [visible]);

	const handleRefresh = async () => {
		console.log('refresh')
		tableRef.current.refresh()	
	}	
	
	const handleOpen = (e) => {		
		if(type==0) return;	
		openDetail();
	};
	
	const openDetail = () => {		
		dlgRef.current.open()
		waitRef(formRef).then(()=>{ formRef.current.open(tableRef.current.getSelectedRecid(),handleRefresh) }) 
	};

	const handleAdd = (e) => {		
		if(type==0) return; 
		dlgRef.current.open()
		waitRef(formRef).then(()=>{formRef.current.open(0,handleRefresh)})	
	};
	
	const handleDelete = async (e) => {			
		await deleteRecord('/loandelete',tableRef.current.getSelectedRecid())
		handleRefresh();	
	};

	const handleNote = (e) => {		
		const selectedRows = tableRef.current.getSelectedRows();
		if(!selectedRows.length) return
		if(!isAdmin() && selectedRows[0].lenderId != getUser().userId) return message.error('Nemáte oprávnění k zobrazení poznámek tohoto záznamu');
		noteDlgRef.current.open()
		waitRef(noteFormRef).then(()=>{noteFormRef.current.open(tableRef.current.getSelectedRecid())})	
	};

	const handleAssign = () => { 
		const recid = tableRef.current.getSelectedRecid();
		if (!recid) return;

		async function assign(recid, sms=false) {
			try {
				const response = await axiosInstance.post('/loanassign', {recid, sms});
				tableRef.current.refresh()	
				if(assigned) assigned();
				message.success('Záznam byl přiřazen');
				openDetail();
				return 0;	
			} catch (err) { 
				handleException(err,false) 
				return err?.response?.data?.errcode
			};
		}
		
		Modal.confirm({title: 'Přiřazení záznamu', content: 'Opravdu chcete přiřadit vybraný záznam?',
			onOk: async () => { 
				const errcode = await assign(recid,true); 
				if(errcode == 9 || errcode == 10) {
					await delay(2000);
					Modal.confirm({title: 'Přiřazení záznamu', content: 'Přejete si přiřadit záznam i bez odeslání sms?', 
						onOk: async () => { await assign(recid); }
					})
				}		
			}
		})	
	}
	
	async function handleUpload({ file }) {
		const formData = new FormData();
		formData.append("file", file);
		try {
			const response = await axiosInstance.post("/uploadcsv", formData, {headers: { "Content-Type": "multipart/form-data" }});
			message.success(`Soubor ${file.name} byl úspěšně zpracován!`);
			tableRef.current.refresh();
		} catch (error) { handleException(error); }
	}

	return (
		<div style={{ display: visible?'block':'none'}}>
			<h1>{params.title}</h1>
			<div className="toolbar">
				<Space> 
					<Button type="primary" icon={<ReloadOutlined/>} onClick={ handleRefresh} >Aktualizovat</Button>
					{type >  0  && <Button icon={<FolderOpenOutlined/>} onClick={ handleOpen} >Otevřít</Button>}
					{type == 0  && assignLoanRight && <Button icon={<PlusOutlined/>} visible={assignLoanRight} onClick={ handleAssign} >Přiřadit</Button>}
					{type >  0 && type < 3 && writeRight && <Upload customRequest={handleUpload}  showUploadList={false}> 
						<Button icon={<UploadOutlined />}>Načíst CSV</Button>
    				</Upload>}
					{type >  0 && type < 3 && writeRight && <Button icon={<PlusOutlined/>} onClick={ handleAdd} >Přidat</Button>}
					{type ==  2  && writeRight && <Button icon={<DeleteOutlined/>} onClick={ handleDelete} >Odebrat</Button>}
					{type ==  1  && <Button icon={<ReadOutlined/>} onClick={ handleNote} >Poznámky</Button>}
				</Space>
				<Input.Search className="toolbar-search"placeholder="Hledat..." onSearch={(value) => tableRef.current.setSearchInput(value)} />
			</div>

			<TableLoan scroll={{ y: tableHeight }} doubleClicked={handleOpen} ref={tableRef}  searchData={params.searchData} lender={params.lender} type={type} />	
			<OpenDialog width={900} title="Půjčka" Component={()=>(<FormLoan writeRight={writeRight} ref={formRef}/>)} ref={dlgRef}/>
			<OpenDialog width={800} title="Poznámky" Component={()=>(<FormNote ref={noteFormRef}/>)} ref={noteDlgRef}/>
		</div>
	);	
};

export default ModuleLoan;

